import { ActionTypes } from 'constants/MogamboConstants';

import { register } from '@src/dispatcher';
import createStore from './StoreUtils.js';

/**
 * Copy Paste Store
 * All the store values that are correspond to copy paste actions come here
 * @type {[type]}
 */
const CopyPasteStore = createStore({
  /**
   * _botResponses: array of bot responses for a particular node
   * _entitySearchData: array of search results for entity search
   * _entityDataForEdit: @TODO
   * _existingEntityNamesData: @TODO
   * @type {[type]}
   */
  _fromData: undefined,
  _dragData: undefined,

  /**
   * Reset the store back to it's original values
   */
  reset() {
    this._fromData = undefined;
    localStorage.removeItem('_copyPasteFromData');
  },

  resetDragData() {
    this._dragData = undefined;
  },

  setFromData(fromData) {
    localStorage._copyPasteFromData = JSON.stringify(fromData);
    this._fromData = fromData;
  },

  getFromData() {
    if (!this._fromData && localStorage._copyPasteFromData) {
      this._fromData = JSON.parse(localStorage._copyPasteFromData);
    }
    return this._fromData;
  },

  setDragData(dragData) {
    this._dragData = dragData;
  },

  getDragData() {
    return this._dragData;
  },
});

/**
 * Listen to actions that are dispatched by the dispatcher and accordingly
 * call some store functions depending on the ActionType
 * @type {[type]}
 */
CopyPasteStore.dispatchToken = register((action) => {
  const actionType = action.type;
  action = action.action;
  switch (actionType) {
    case ActionTypes.COPY_SUBSTORY:
    case ActionTypes.COPY_SUBSTORY_RESET:
      CopyPasteStore.setFromData(action.fromData);
      CopyPasteStore.emitChange();
      break;
    case ActionTypes.COPY_NODE:
      CopyPasteStore.setFromData(action.fromData);
      CopyPasteStore.emitChange();
      if (action.callback) setTimeout(action.callback, 0);
      break;
    case ActionTypes.COPY_PASTE_RESET:
      CopyPasteStore.reset();
      CopyPasteStore.emitChange();
      break;
    case ActionTypes.DRAG_NODE:
      CopyPasteStore.setDragData(action.dragData);
      CopyPasteStore.emitChange();
      break;
    case ActionTypes.DRAG_DROP_RESET:
      CopyPasteStore.resetDragData();
      CopyPasteStore.emitChange();
      break;
    default:
  }
});

export default CopyPasteStore;
